<template>
  <div class="tan_needGz_portrait_isHaveChangeWrap" v-if="newAllData">
    
    <div class="txjyWrap">
      <!-- <div class="refer_comTit2 border_no paddindNo heightAuto" >
        <img class="reIcon" src="../../../assets/report_icon_notice_d@2x.png" alt="">
        <div class="ml5">最近30天里</div>
        <div class="colorFF7186">2月18日</div>
        <div>离床次数</div>
        <div class="colorFF7186">14次</div>
        <div>，和平时差异比较大，可以关注一下，和平时差异比较大，可以关注一下，和平时差异比较大，可以关注一下，和平时差异比较大，可以关注一下</div>
      </div> -->
      <div class="refer_comTit2 border_no paddindNo heightAuto cursorPointer" v-if="newAllData.descLabel"  v-html="$options.filters.reMate(newAllData.descLabel)"></div>
      
      <div class="fer_txjyWrap mt10" :style="{ paddingBottom: fer_txjy_isZk ? '15px' : '0',}">
        <div class="fer_txjy" @click="fer_txjy_isZk = !fer_txjy_isZk" :style="{ borderBottom: fer_txjy_isZk ? '1px solid #E8EAEE' : '0',}">
          <div>提醒和建议</div>
          <img class="fer_txjyIcon mlAuto" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!fer_txjy_isZk">
          <img class="fer_txjyIcon mlAuto" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="fer_txjy_isZk">
        </div>
        <div class="fer_txjy border_no pt15 heiAuto" v-if="fer_txjy_isZk">
          <div>{{newAllData.remindAndSuggestLabel}}</div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';

export default {
  components: {  },
  filters: {
    reMate(val){
      return CustomRichText.reMate(portFn.function_reg_str_to_arr(val))
    },
  },
  props: {
    haveChangeData: null,
  },
  watch: {
    haveChangeData(newVal,oldVal){
      this.newAllData = newVal
      console.log('进入了haveChange组件 且有变化了')
      console.log(this.newAllData)
    }
  },
  data() {
    return {
      newAllData: null,
      fer_txjy_isZk: true,
    };
  },
  created() {},
  mounted() {
    this.newAllData = this.haveChangeData
    
  },
  methods: {
    
    
    


    
    
  },
};
</script>
<style lang="scss" scoped>

.tan_needGz_portrait_isHaveChangeWrap ::v-deep{

  .txjyWrap{
    width: 810px;
    height: auto;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid rgba(255,113,134,0.5);
    padding: 15px;
    box-sizing: border-box;
    display: block;
    .txjyTit{
      width: 356px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1F2635;
      margin-left: 14px;
      position: relative;
    }
    .txjyTit::after{
      width: 4px;
      height: 14px;
      background: #FF7186;
      border-radius: 2px;
      content: '';
      position: absolute;
      left: -14px;
      top: 5px;
    }
    .txjyTit_after_blue::after{
      background: #1890FF;
    }
    .txjyTit2{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9094A6;
      line-height: 20px;
      margin-top: 10px;
    }
    .refer_comTit{
      width: 780px;
      height: auto;
      background: #F3F4F7;
      border-radius: 4px;
      padding: 12px;
      box-sizing: border-box;

                  
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5E6779;
      position: relative;
    }
    .refer_comTit::after{
      content: '';
      width: 0px;
      height: 0px;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 12px solid #F3F4F7;
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
    }
    .refer_comLine_heng{
      width: 780px;
      height: 1px;
      opacity: 0.1;
      border: 1px solid #1F2635;
      margin-top: 15px;
    }
    .refer_comTit2{
      width: 780px;
      height: 52px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1F2635;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid rgba(255,113,134,0.5);
      padding: 0 15px;
      box-sizing: border-box;
      // display: flex;
      align-items: center;
      .reIcon{
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
    }
    .fer_txjyWrap{
      width: 780px;
      height: auto;
      background: #F3F4F7;
      border-radius: 4px;
      padding: 0 15px 15px 15px;
      .fer_txjy{
        width: 750px;
        height: 46px;
        border: 0;
        border-bottom: 1px solid #E8EAEE;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9094A6;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      .fer_txjyIcon{
        width: 14px;
        height: 14px;
      }
      
    }
    .lcTimeTip{
      display: flex;
      justify-content: center;
      align-items: center;
      .lcTimeKuang{
        width: 16px;
        height: 5px;
        background: #E0ECFC;
      }
      .lcTimeFont{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A5A9BC;
      }
    }
    .lcscSinWrap{
      width: 780px;
      height: auto;
      background: #F8F8FC;
      border-radius: 8px;
      padding: 12px 15px;
      box-sizing: border-box;
      .name{
        width: 96px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A5A9BC;
      }
      .boxBg{
        width: 750px;
        height: 8px;
        border-radius: 6px;
      }
      .boxBgData{
        width: 750px;
        height: 20px;
        display: flex;
        margin-top: 4px;
        .bNum{
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #A5A9BC;
          margin-left: 67.5px;
          position: relative;
        }
        .bNum:nth-of-type(1){
          margin-left: 0;
        }
      }
    }
    .zxSanWrap{
      display: flex;
      align-items: center;
      justify-content: center;
      .zxSanList{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A5A9BC;
        padding-left: 22px;
        box-sizing: border-box;
        position: relative;
      }
      .zxSanList::after{
        content: '';
        width: 6px;
        height: 6px;
        background: #FF7186;
        border-radius: 50%;
        position: absolute;
        left: 12px;
        top: 6px;
      }
      .zxSanList:nth-of-type(2):after{
        background: #FFB971;
      }
      .zxSanList:nth-of-type(3):after{
        background: #44D7B6;
      }
      .zxSanList:nth-of-type(4):after{
        background: #1890FF;
      }
    }
    .zxSanBotCont{
      width: 780px;
      height: auto;
      padding: 15px;
      box-sizing: border-box;
      background: #F3F4F7;
      border-radius: 4px;
      position: relative;
      .zxSanBotListWrap{
        display: flex;
        .zxSanBotList{
          width: 180px;
          height: 73px;
          background: #FFFFFF;
          border-radius: 4px;
          margin-left: 10px;
          .zxBoxBlock{
            width: 16px;
            height: 5px;
            background: #FFD4DA;
          }
          .zxBoxName{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A5A9BC;
          }
        }
        .zxSanBotList:nth-of-type(1){
          margin-left: 0;
        }
      }
    }
    .zxSanBotCont::after{
      content: '';
      width: 0px;
      height: 0px;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 12px solid #F3F4F7;
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
    }

  }
  .fer_txjyWrap{
    width: 780px;
    height: auto;
    background: #F3F4F7;
    border-radius: 4px;
    padding: 0 15px 15px 15px;
    .fer_txjy{
      width: 750px;
      height: 46px;
      border: 1px solid #E8EAEE;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9094A6;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
    .fer_txjyIcon{
      width: 14px;
      height: 14px;
    }
    
  }
}

</style>
